var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Video goes here")]),_c('button',{on:{"click":function($event){return _vm.$emit('conditions_met', 'video')}}},[_vm._v("woop")])])
}
var staticRenderFns = []

export { render, staticRenderFns }